<template>
  <div class="tw-flex tw-items-end tw-overflow-x-auto">
    <ul class="tw-flex tw-text-center">
      <slot></slot>
    </ul>
    <div
      class="tw-inline-block tw-w-full tw-border-b tw-border-secondary-500"
    />
  </div>
</template>

<script lang="ts" setup></script>
